export default ({ fnClassButton }) => ({
  id: 'stock',
  mode: {
    isModalNew: true,
    isModalEditing: true
  },
  'isAutoLoad': false,
  'store': {
    'get': {
      'url': 'Stocks/GetAllDynamic',
      'selected': [
        'id', 'statusID', 'tagDate', 'tagInfoCompany.name as tagBy', 'stockLocation.title as stockLocationTitle',
        'part.partNumber as partNumber', 'partSN', 'part.partDescription as partDescription', 'entryDate',
        'baxpoNumber', 'qty', 'condition.title as conditionTitle', 'release.title as releaseTitle',
        'status.title as statusTitle', 'physicalStock', 'sellPrice', 'sellExchCurrency.title as currencyTitle'
      ]
        .join(','),
      'filters': 'partSN != null'
    },
    'create': {
      'url': 'Stocks/Create'
    },
    'patch': {
      // eslint-disable-next-line no-template-curly-in-string
      'url': 'Stocks/Patch/${data.id}'
    },
    'delete': {
      // eslint-disable-next-line no-template-curly-in-string
      'url': 'Stocks/Delete/${data.id}',
      'modal': {
        'msgDataKey': 'partSN'
      }
    }
  },
  'header': {
    'title': {
      'isVisible': false
    },
    'controls': {
      'isRefresh': false,
      'export': {
        'isVisible': false
      },
      'addNew': {
        'isVisible': false
      }
    }
  },
  'columns': [
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': '${root.L10n("part-SN")}',
      'field': 'partSN',
      'editor': {
        'type': 'string',
        'required': true
      },
      'styles': {
        'minWidth': '15rem'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': '${root.L10n("part-number")}',
      'field': 'partNumber',
      'sortable': {
        'custom': 'part.partNumber'
      },
      'editor': {
        'type': 'select',
        'remote': true,
        'field': 'partID',
        // eslint-disable-next-line no-template-curly-in-string
        'permission': '${data.id === 1 || data.id === 2}',
        'required': true,
        'data': {
          'url': 'Parts/GetAllDynamic',
          'selected': 'id,partDescription,partNumber as title'
        }
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('condition')}",
      'field': 'conditionTitle',
      'sortable': {
        'custom': 'condition.title'
      },
      'editor': {
        'type': 'select',
        'field': 'conditionID',
        'data': 'Conditions/GetAllDynamic?select=id,title&orderBy=title asc'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('location')}",
      'field': 'stockLocationTitle',
      'sortable': {
        'custom': 'stockLocation.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('tag-date')}",
      'field': 'tagDate',
      'template': 'date',
      'editor': {
        'type': 'date'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('tag-by')}",
      'field': 'tagBy',
      'sortable': {
        'custom': 'tagInfoCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('status')}",
      'field': 'statusTitle',
      'sortable': {
        'custom': 'status.title'
      },
      'editor': {
        'type': 'select',
        'field': 'statusID',
        'data': 'Statuses/GetAllDynamic?select=id,title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('qty')}",
      'field': 'qty',
      'editor': {
        'type': 'number',
        'required': true
      },
      'styles': {
        'minWidth': '15rem'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('part-description')}",
      'field': 'partDescription',
      'sortable': {
        'custom': 'part.partDescription'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('baxpo-number')}",
      'field': 'baxpoNumber',
      'editor': {
        'type': 'string'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('release')}",
      'field': 'releaseTitle',
      'sortable': {
        'custom': 'release.title'
      },
      'editor': {
        'type': 'select',
        'field': 'releaseID',
        'data': 'Releases/GetAllDynamic?select=id,title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': "${root.L10n('physical-stock')}",
      'field': 'physicalStock',
      'template': 'boolean',
      'editor': {
        'type': 'checkbox'
      }
    }
  ],
  'rowControls': {
    'right': {
      'classes': 'controls-inline',
      'controls': [
        {
          'type': 'edit'
        },
        {
          'type': 'custom',
          // eslint-disable-next-line no-template-curly-in-string
          'title': "${root.L10n('quick-rfq')}",
          buttonClass: fnClassButton,
          'permission': 'isAllowToEditRFQs'
        }
      ]
    }
  },
  'toolbar': {
    'filters': [
      {
        'type': 'string',
        'field': 'title',
        'options': {
          // eslint-disable-next-line no-template-curly-in-string
          'valueTemplate': '( part.partNumber.StartsWith("${data.value}") || partSN.contains("${data.value}") || part.partDescription.StartsWith("${data.value}") || baxPONumber.contains("${data.value}") )',
          // eslint-disable-next-line no-template-curly-in-string
          'placeholder': "${root.L10n('search')}",
          'styles': {
            'maxWidth': '15rem'
          }
        }
      },
      {
        'type': 'selectautocomplete',
        'field': 'supplierCompanyID',
        // eslint-disable-next-line no-template-curly-in-string
        'label': "${root.L10n('supplier-company')}",
        'options': {
          // eslint-disable-next-line no-template-curly-in-string
          'templateFilter': 'name.StartsWith("${data.search}")',
          'dataSource': {
            'url': 'Companies/GetAllDynamic',
            'selected': 'id,name',
            'take': 50
          },
          'option': {
            'label': 'name'
          },
          // eslint-disable-next-line no-template-curly-in-string
          'placeholder': "${root.L10n('all')}",
          'styles': {
            'maxWidth': '15rem'
          }
        }
      },
      {
        'type': 'select',
        'field': 'conditionID',
        // eslint-disable-next-line no-template-curly-in-string
        'label': "${root.L10n('condition')}",
        'options': {
          'dataSource': 'Conditions/GetAllDynamic?select=id,title&orderBy=title asc',
          // eslint-disable-next-line no-template-curly-in-string
          'placeholder': "${root.L10n('all')}",
          'styles': {
            'maxWidth': '15rem'
          }
        }
      },
      {
        'type': 'select',
        'field': 'statusID',
        // eslint-disable-next-line no-template-curly-in-string
        'label': "${root.L10n('status')}",
        'options': {
          'dataSource': [
            {
              'id': 1,
              'title': 'Available'
            },
            {
              'id': 2,
              'title': 'Sold'
            }
          ],
          // eslint-disable-next-line no-template-curly-in-string
          'valueTemplate': '(${data.field}${data.value == 2 ? " == 2" : " != 2"})',
          // eslint-disable-next-line no-template-curly-in-string
          'placeholder': "${root.L10n('all')}",
          'clearable': false,
          'value': 1,
          'styles': {
            'maxWidth': '15rem'
          }
        }
      }
    ]
  },
  'permission': {
    'edit': 'isAllowToEditStocks'
  }
})
